import Footer from './../components/Footer'
import { Outlet } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import GlobeLoader from '../components/GlobeLoader';
import Header from '../components/AppBar';

const WebsiteLayout = () => {
    const [loading, setLoading] = useState(true);
    useEffect(()=> {
        const load = async ()=> {
            setTimeout(()=> setLoading(false), 1000)
            // setLoading((loading)=> !loading)
        }
        load()
    }, []);
    if(loading) {
        return (
            <GlobeLoader />
        )
    } else {
    return (<>
            {/* <Navbar /> */}
            <Header />
            <div style={{ minHeight: '65vh', marginTop:'80px' }}>
                <Outlet />
            </div>
            <Footer />
    </>)}
}

export default WebsiteLayout;